import React, { useEffect, useState } from "react";
import SVG from "src/utils/SVG";
import Box from "src/components/common/Box";
import Button from "src/components/common/Button";
import IconButton from "src/components/common/IconButton";
import Modal, { RefProps } from "src/components/common/Modal";
import InfoModalItem from "./InfoModalItem";
import styled from "styled-components";
import CheckModalItem from "./CheckModalItem";
import { getPathValue } from "src/utils/queryStringUtil";
import { useAsDetailQuery } from "src/api/asAPI";
import { useAppDispatch, useAppSelector } from "src/store/actions/action";
import { EstimateGoods, EstimateVo } from "src/vo/estimateVo";
import { deleteGoodsReduce, goodsClickReduce, setValueChange } from "src/store/reducers/estimateReduce";
import { useAddEstimateMutation } from "src/api/estimateAPI";
import { useNavigate } from "react-router-dom";
import { addCommas } from "src/utils/addCommas";

interface propsData {
  add?: boolean;
  reRegister?: boolean;
}

const AddEstimateItem = (props: propsData) => {
  const { add, reRegister } = props;

  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const index: any = getPathValue();
  const asDetail = useAsDetailQuery(index);

  const estimateGoodsList: any = useAppSelector((state) => state.estimateReduce.estimate_goods_list);
  const estimateGoods = useAppSelector((state) => state.estimateReduce.estimate_goods_update);

  // ================== API 영역 ==================

  const [insertEstimate, { isLoading: isUpdating, error: setError, isSuccess }] = useAddEstimateMutation();

  const [inputs, setInputs] = useState({
    free: "",
    totalPrice: 0,
    es_idx: 0,
    freeYn: "",
  });

  const { free, totalPrice, es_idx, freeYn } = inputs;

  const [goodsIdx, setGoodsIdx] = useState(0);

  useEffect(() => {
    if (asDetail.data) {
      setInputs({
        ...inputs,
        free: asDetail.data.free_yn === "Y" ? "무상" : "",
        totalPrice: 0,
        es_idx: asDetail.data.es_idx,
        freeYn: asDetail.data.free_yn,
      });
    }
  }, [asDetail]);

  useEffect(() => {
    if (estimateGoodsList) {
      if (estimateGoodsList.length > 0) {
        let total = 0;
        for (let i = 0; i < estimateGoodsList.length; i++) {
          const oneTotalPrice = Number(estimateGoodsList[i].unit_price) * Number(estimateGoodsList[i].qty);
          const roundOneTotalPrice = Math.round(oneTotalPrice);
          total += Number(roundOneTotalPrice);
        }
        setInputs({
          ...inputs,
          totalPrice: asDetail.data.free_yn === "Y" ? 0 : total,
        });
      } else {
        setInputs({
          ...inputs,
          totalPrice: 0,
        });
      }
    }
  }, [add, estimateGoodsList]);

  const deleteGoods = (index: number) => {
    dispatch(deleteGoodsReduce(index));
  };

  const estimateRegister = async () => {
    if (estimateGoodsList.length <= 0) {
      alert("견적서 내용을 입력해주세요");
      return;
    }

    const params = {
      as_idx: index,
      total_price: totalPrice,
      estimateGoods: estimateGoodsList,
    };
    await insertEstimate(params);
  };

  useEffect(() => {
    if (isSuccess) {
      // navigate("/estimate-detail/" + es_idx);
      navigate("/as-detail/" + index, { replace: true });
    }
  }, [isSuccess]);

  useEffect(() => {
    if (setError) {
      alert("시스템 오류 입니다. 다시 시도해 주시기 바랍니다.");
    }
  }, [setError]);

  const cancelEstimate = () => {
    if (checkModalRef.current) checkModalRef.current.modalClose();
  };

  // 클릭 이벤트 영역
  const historyCheck = () => {
    dispatch(goodsClickReduce(estimateGoodsList[goodsIdx]));
    dispatch(deleteGoodsReduce(goodsIdx));
  };

  // +++++++++++++++++++++++++ 퍼블리싱 영역 +++++++++++++++++++++++++
  const infoModalRef = React.useRef<RefProps>(null);
  const checkModalRef = React.useRef<RefProps>(null);

  const openInfoModal = () => {
    if (infoModalRef.current) infoModalRef.current.modalOpen();
  };

  const openCheckModal = () => {
    if (checkModalRef.current) checkModalRef.current.modalOpen();
  };

  return (
    <>
      <ItemsTable>
        <colgroup>
          <col width="*" />
          <col width="80px" />
          <col width="50px" />
          <col width="30px" />
        </colgroup>
        <thead>
          <tr>
            <th>품명</th>
            <th>단가</th>
            <th>수량</th>
            <th>
              <span className="hidden">삭제</span>
            </th>
          </tr>
        </thead>
        <tbody>
          {estimateGoodsList?.map((value: EstimateGoods, k: number) => {
            return (
              <tr key={k}>
                <td>
                  <EditBtn
                    onClick={() => {
                      openInfoModal(), setGoodsIdx(k);
                    }}
                  >
                    {value.goods_name}
                  </EditBtn>
                </td>
                <td>{addCommas(value.unit_price)}</td>
                <td>{addCommas(value.qty)}</td>
                <td>
                  <IconButton btnName="행삭제" onClick={() => deleteGoods(k)}>
                    <SVG name="trDel" width={20} height={20} viewBox="0 0 20 20" />
                  </IconButton>
                </td>
              </tr>
            );
          })}
        </tbody>
      </ItemsTable>
      <TableFooter>
        <div>
          <p>총 견적금액 {free !== "" ? "(" + free + ")" : ""}</p>
          <p>
            <span>{addCommas(totalPrice)}</span> 원
          </p>
        </div>
      </TableFooter>

      {estimateGoodsList.length > 0 ? (
        <Box pd="15px 30px 0">
          <Button variant="contained" br="round" onClick={openCheckModal}>
            {reRegister ? "견적 수정" : "완료"}
          </Button>
        </Box>
      ) : (
        ""
      )}

      <Modal ref={infoModalRef} leftBtnText="취소" rightBtnText="내역 확인" onClick2={historyCheck}>
        <InfoModalItem />
      </Modal>

      <Modal ref={checkModalRef} leftBtnText="취소" rightBtnText="등록" onClick={() => cancelEstimate()} onClick2={() => estimateRegister()}>
        <CheckModalItem freeYn={freeYn} />
      </Modal>
    </>
  );
};

const ItemsTable = styled.table`
  width: 100%;
  thead {
    border-bottom: 1px solid ${({ theme }) => theme.color.linePrimary};
    th {
      padding-bottom: 10px;
      color: #60677d;
      font-size: 14px;
      text-align: right;
      &:first-child {
        padding-left: 30px;
        text-align: left;
      }
    }
  }
  tbody {
    td {
      padding-top: 12px;
      color: #000;
      font-size: 14px;
      font-weight: 500;
      text-align: right;
      vertical-align: middle;
      &:first-child {
        padding-left: 30px;
        text-align: left;
      }
    }
  }
`;

const EditBtn = styled.button`
  padding: 0;
  border: none;
  background: none;
  appearance: none;
  text-decoration: underline;
  text-align: left;
  cursor: pointer;
`;

const TableFooter = styled.div`
  padding: 24px 30px 0;
  > div {
    padding-top: 10px;
    border-top: 2px solid #000;
    ${({ theme }) => theme.flexBox.flexMixin()}
    color: #000;
    font-size: 18px;
    font-weight: 700;
    > p:last-child {
      color: ${({ theme }) => theme.color.main};
    }
  }
`;

export default AddEstimateItem;
